/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

export default {
    /**
     * GET
     */
    get: function(){
        return axios.get( FH_CONFIG.BASE_URL + '/settings/business/users' );
    },
}